<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Directory') }}</h1>
          <template v-if="totalCount === 0 || totalCount === 1">
            <h2 class="page-subtitle">{{ totalCount }} {{ $t('contact') }}</h2>
          </template>
          <template v-else>
            <h2 class="page-subtitle">{{ totalCount }} {{ $t('contacts') }}</h2>
          </template>
        </div>
        <b-button v-if="allowCreate" class="btn-medium" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a') }} {{ $t('contact') }}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableContact"
          :delete-item=allowDelete
          :edit-item=allowEdit
          :empty-button="$t('contact.emptyButton').toString()"
          :empty-text="$t('contact.emptyText').toString()"
          :empty-title="$t('contact.emptyTitle').toString()"
          :fields="tableFields"
          get-b122-table-results-url="/contact/getB122TableResults"
          identifier="B122TableContact"
          init-b122-table-url="/contact/initB122Table"
          @add="clickOnCreateBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnShowBtn="clickOnShowBtn"
          @setTotalCount="setTotalCount">

          <template #cell(tostring)="data">
            {{ data.item.toString }}
            <template v-if="data.item.nbAlertDocuments>0">
              <svg class="icon icon-tabler icons-tabler-outline icon-tabler-file-alert" fill="none" height="24" stroke="#DD8F25" stroke-linecap="round"
                   stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                   xmlns="http://www.w3.org/2000/svg">
                <title>Expire bientôt</title>
                <path d="M0 0h24v24H0z" fill="none" stroke="none"/>
                <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/>
                <path d="M12 17l.01 0"/>
                <path d="M12 11l0 3"/>
              </svg>
            </template>
            <template v-else-if="data.item.nbValidDocuments>0">
              <svg class="icon icon-tabler icons-tabler-outline icon-tabler-file-check" fill="none" height="24" stroke="#07153C" stroke-linecap="round"
                   stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                   xmlns="http://www.w3.org/2000/svg">
                <title>Valide</title>
                <path d="M0 0h24v24H0z" fill="none" stroke="none"/>
                <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/>
                <path d="M9 15l2 2l4 -4"/>
              </svg>
            </template>
            <template v-else-if="data.item.nbHistoryDocuments>0">
              <svg class="icon icon-tabler icons-tabler-outline icon-tabler-file-x" fill="none" height="24" stroke="#9E0430" stroke-linecap="round"
                   stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                   xmlns="http://www.w3.org/2000/svg">
                <title>Expiré</title>
                <path d="M0 0h24v24H0z" fill="none" stroke="none"/>
                <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/>
                <path d="M10 12l4 4m0 -4l-4 4"/>
              </svg>
            </template>
          </template>

          <template #cell(actions)="row">
            <div class="actions-container text-right">
              <button class="show-action-btn edit mr-1"
                      @click=clickOnEditBtn(row)>
                <pencil-icon size="18"/>
              </button>
              <button class="show-action-btn delete"
                      @click=clickOnDeleteBtn(row)>
                <trash-icon size="18"/>
              </button>
            </div>
          </template>
        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItem="selectedContact"
      controllerName="contact"
      itemSingularName="contact"
      itemSingularNameUpp="Contact"
      @didDeleteItem="didDeleteContact()">
    </Item-delete-modal>
  </div>

</template>

<script>

import B122Table from "../../components/b122/B122Table";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";

export default {
  name: "ContactIndex",

  components: {
    B122Table,
    ItemDeleteModal
  },

  data() {
    return {
      totalCount: 0,
      username: this.$store.getters.username,
      isEstateAgent: this.$store.getters.isEstateAgent,
      allowCreate: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,
      allowEdit: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,
      allowDelete: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,

      selectedContact: null
    }
  },

  computed: {
    tableFields() {
      let tableFields = [
        {
          label: this.$t('See'),
          key: 'show',
          sortable: false
        },
        {
          label: this.$t('contact.Lastname') + ' ' + this.$t('contact.Firstname'),
          key: 'tostring',
          sortable: false
        },
        {
          label: this.$t('contact.Type'),
          key: 'type',
          sortable: true
        },
        {
          label: this.$t('contact.City'),
          key: 'city',
          sortable: true
        },
        {
          label: this.$t('contact.PhoneNumber'),
          key: 'phoneNumber',
          sortable: false
        },
        {
          label: this.$t('contact.Mail'),
          key: 'mail',
          sortable: true
        },
        {
          label: '',
          key: 'actions'
        }]
      return tableFields
    }

  },

  methods: {
    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'ContactCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'ContactShow',
        params: {
          contactId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'ContactEdit',
        params: {
          contactId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.selectedContact = row.item
      if (this.selectedContact && this.selectedContact.operationDevis && this.selectedContact.operationDevis.length > 0) {
        this.$alert(this.$i18n.t('contact.cant.delete.devis.linked', {contactName: this.selectedContact.tostring}).toString()).then(() => {
        });
      } else {
        this.$bvModal.show('item-delete-modal')
      }
    },

    didDeleteContact() {
      this.selectedContact = null
      this.$refs.B122TableContact.refreshTable()
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/contact/ContactIndex.vue